$(document).ready(function () {
    const wishlist_button_accessor = '.chalet-card button.chalet-card-heart, .chalet-card button.chalet-card-bin, .chalet button.__wishlist';

    $(document).on('click', wishlist_button_accessor, function(e) {

        let $button = $(this);

        // Use self if button on single-chalet page
        let $card = ($button.hasClass('__wishlist')) ? $(this) : $button.parents('.chalet-card');

        let _id = $button.data('location-id');
        let _action = ($card.hasClass('__saved')) ? 'wishlist_remove' : 'wishlist_add';

        console.log("Wishlist button", _id, _action);

        $.post(wishlist_action.url, {
            action: _action,
            id: _id,
            _ajax_nonce: wishlist_action.nonce
        })
        .done(function(response) {

            if ('wishlist_add' == response.data.action) {

                $card.addClass('__saved');

            } else {


                $card.removeClass('__saved');

                if ($button.hasClass('chalet-card-bin')) {
                    $card.parent().remove();
                }

            }

        })
        .fail(function(xhr, status, err) {
            console.log("Wishlist button error", xhr);
        })
    });
});